import * as tasksTypes from './tasksTypes';

const initialState = {
  dynamicContent: {},
  tasks: [],
  isLoading: false,
  initials: '',
  name: '',
  isShowProfileIconName: false,
};

const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case tasksTypes.SET_SHOW_PROFILE_ICONNAME_STATE: {
      return {
        ...state,
        isShowProfileIconName: action.payload,
      };
    }

    case tasksTypes.GET_TASKS_SUCCESS: {
      return {
        ...state,
        tasks: action.payload,
      };
    }

    case tasksTypes.GET_TASK_PROFILE_SUCCESS: {
      return {
        ...state,
        name: action.payload.name,
        initials: action.payload.initials,
      };
    }

    case tasksTypes.LOADING_TASKS: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export { initialState };
export default tasksReducer;
